export default __webpack_public_path__ + "media/images/actright-a6affbd67d8b5bb63b29f40d0fdd388a.png";